/* C268: quick buy for blank apparel, ported from BLANKS-CATALOG-UI-HANDOFF.md section 6.
 *
 * The theme's own quick buy renders the variant picker INLINE in the card, growing it from 349px
 * to 657px and leaving "Choose a variant first" sitting in the grid. Blanks need a bar on the
 * card that opens a modal, because a style carries up to 70 colours and 8 sizes and the shopper
 * usually wants several sizes of ONE colour.
 *
 * Lives in its own asset on purpose (the deploy-around pattern): a change in a body-class-gated
 * file cannot carry anyone else's drift the way an edit buried in shared theme.css can.
 */
(function () {
  'use strict';
  /* C284: runs on blanks collections AND anywhere the upsell rail is, which is how the
     handoff intended the modal to be reused: any element carrying data-bqb-handle. */
  /* C356: also on blank product pages, whose "You may also like" cards arrive later over AJAX (the row marks itself
     data-np-blank-recs from the start, and the observer below picks the cards up when they land) */
  if (!document.querySelector('.npbc-head') && !document.querySelector('[data-bqb-handle]') &&
      !document.querySelector('[data-np-blank-recs]')) return;
  if (window.__npBlanksQuickBuy) return;
  window.__npBlanksQuickBuy = true;

  var cache = Object.create(null);
  var modal = null, state = null;

  /* C405 (Justin 2026-09-23, "show the slash through price on quick buy modal too"): the same struck retail reference the
     blank product page shows (C363) — price x 1.96, ninjatransfers.com's RETAIL_PRICE_MULTIPLIER, unless the variant
     carries a higher compare-at of its own. Keep in step with np-blank-pdp.js and main-product.liquid. */
  var RETAIL_MULTIPLIER = 1.96;
  function wasFor(v) {
    var w = Math.round(v.price * RETAIL_MULTIPLIER);
    if (v.compare_at_price && v.compare_at_price > w) w = v.compare_at_price;
    return w;
  }
  /* C410: "OS" sizes read "One Size". Display only; the variant keeps its "OS" value. */
  function sizeLabel(s) { return /^\s*os\s*$/i.test(s || '') ? 'One Size' : s; }
  /* C527 (Justin 2026-10-28, "when you click into a size section with a size it should select all"): a size box selects
     its number on focus, so typing replaces it. The click that focused it would drop the caret back in on mouseup, so
     that one mouseup is cancelled; the deferred re-select is for iOS, which ignores a select() made during focus.
     Same helper in np-blank-pdp.js. */
  function selectAllOnFocus(inp) {
    var byPointer = false;
    inp.addEventListener('mousedown', function () { byPointer = document.activeElement !== inp; });
    inp.addEventListener('focus', function () {
      inp.select();
      setTimeout(function () { if (document.activeElement === inp) inp.setSelectionRange(0, inp.value.length); }, 0);
    });
    inp.addEventListener('mouseup', function (e) { if (byPointer) e.preventDefault(); byPointer = false; });
  }
  function money(cents) {
    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }
  function hexFor(name) {
    var t = window.NP_BLANK_COLORS || window.NT_BLANK_COLORS;
    if (!t || !name) return null;
    var up = String(name).trim().toUpperCase().replace(/\s+/g, ' ');
    return t[up] || null;
  }
  function load(handle) {
    if (cache[handle]) return cache[handle];
    cache[handle] = fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return cache[handle];
  }
  function optionIndex(p, want) {
    for (var i = 0; i < (p.options || []).length; i++) {
      var n = (p.options[i].name || p.options[i] || '').toString().toLowerCase();
      if (want.indexOf(n) > -1) return i;
    }
    return -1;
  }

  /* ── trigger bar on every card ────────────────────────────────────────────────────────────── */
  function addTriggers(root) {
    var cards = (root || document).querySelectorAll('.product-item, [data-bqb-handle]');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.getAttribute('data-bqb') === '1') continue;
      var link = card.querySelector('a[href*="/products/"]');
      var handle = card.getAttribute('data-bqb-handle') ||
        (link ? (link.getAttribute('href') || '').split('/products/').pop().split('?')[0].split('#')[0] : '');
      if (!handle) continue;
      card.setAttribute('data-bqb', '1');
      /* C294: NOT .grt-qv-wrap — that is the quick-VIEW eye wrapper, which C284 hides with
         display:none, so the bar went inside a hidden box and measured 0x0. The media box is
         the right host: it is position:relative and sized. */
      var host = card.querySelector('.product-item__image')
              || card.querySelector('.grt-product-card__media')
              || card;
      /* the theme's .product-item__image-figure carries z-index 99; anything lower slides up
         BEHIND the photo and leaks a dark sliver at the corners. */
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'bqb-trigger';
      /* C389 (Justin 2026-09-23, "lets update quick buy to look like this"): cart glyph + label, as on dtftransfers.com */
      btn.innerHTML = '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2"' +
        ' stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<circle cx="9" cy="20" r="1.4"></circle><circle cx="18" cy="20" r="1.4"></circle>' +
        '<path d="M2 3h2.5l2.6 12.2a1.6 1.6 0 0 0 1.6 1.3h8.9a1.6 1.6 0 0 0 1.6-1.2L21.5 7H6"></path></svg>' +
        '<span>Quick buy</span>';
      btn.setAttribute('data-bqb-open', handle);
      if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
      host.appendChild(btn);
    }
  }

  /* ── modal ────────────────────────────────────────────────────────────────────────────────── */
  function ensureModal() {
    if (modal) return modal;
    modal = document.createElement('div');
    modal.className = 'bqb-modal';
    modal.setAttribute('hidden', '');
    /* C271: layout mirrors dtftransferss — image full-bleed down the left half, everything else
       in a padded right column, sizes as COLUMNS (label over stepper over price) rather than a
       vertical list. Accent is #4DB47F, the green the rest of this store already uses. */
    modal.innerHTML =
      '<div class="bqb-modal__veil" data-bqb-close></div>' +
      '<div class="bqb-modal__panel" role="dialog" aria-modal="true" aria-label="Quick buy">' +
        '<button type="button" class="bqb-modal__x" data-bqb-close aria-label="Close">&times;</button>' +
        '<div class="bqb-left"><img class="bqb-hero" alt=""></div>' +
        '<div class="bqb-right">' +
          '<h2 class="bqb-title"></h2>' +
          /* C392 (Justin 2026-09-23, "view full details should open in new browser from quick buy") */
          '<a class="bqb-full" href="#" target="_blank" rel="noopener">View full details</a>' +
          '<div class="bqb-aslow">AS LOW AS</div>' +
          '<div class="bqb-low"></div>' +
          '<div class="bqb-colourrow">' +
            '<span class="bqb-colourlabel">Color:</span>' +
            '<span class="bqb-colourpill"><span class="bqb-colourchip"></span><span class="bqb-colourname"></span></span>' +
            '<span class="bqb-colourcount"></span>' +
          '</div>' +
          '<div class="bqb-swatches"></div>' +
          '<div class="bqb-sizehead">Choose size(s)</div>' +
          '<div class="bqb-sizes"></div>' +
          /* C338: the add button sits in a row so a one-size style can put its stepper beside it */
          '<div class="bqb-buyrow"><div class="bqb-buyqty" hidden></div>' +
          '<button type="button" class="bqb-add"></button></div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(modal);
    modal.addEventListener('click', function (e) {
      if (e.target.hasAttribute && e.target.hasAttribute('data-bqb-close')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hasAttribute('hidden')) close();
    });
    modal.querySelector('.bqb-add').addEventListener('click', addToCart);
    return modal;
  }
  function close() {
    if (!modal) return;
    modal.setAttribute('hidden', '');
    document.documentElement.style.overflow = '';
    state = null;
  }

  function open(handle, preselect) {
    ensureModal();
    modal.removeAttribute('hidden');
    document.documentElement.style.overflow = 'hidden';
    modal.querySelector('.bqb-title').textContent = 'Loading...';
    modal.querySelector('.bqb-sizes').innerHTML = '';
    modal.querySelector('.bqb-swatches').innerHTML = '';
    modal.querySelector('.bqb-add').textContent = 'Add to cart';
    load(handle).then(function (p) {
      if (!p) { modal.querySelector('.bqb-title').textContent = 'Could not load this product.'; return; }
      var ci = optionIndex(p, ['color', 'colour']);
      var si = optionIndex(p, ['size']);
      /* C333 (Justin 2026-09-23, "why are we showing color options that are all sold out?"): a colour
         is offered only when at least one of its sizes can be bought. The VC300A dad hat listed all 42
         colours; 4 of them had no size in stock, so picking one opened a grid of "Sold out" and a dead
         Add to cart. Every colour is kept only as a fallback when nothing at all is in stock, so the
         modal never opens empty. */
      var colours = [], inStock = [];
      for (var v = 0; v < p.variants.length; v++) {
        var n = ci > -1 && p.variants[v].options ? p.variants[v].options[ci] : null;
        if (n && colours.indexOf(n) < 0) colours.push(n);
        if (n && p.variants[v].available && inStock.indexOf(n) < 0) inStock.push(n);
      }
      if (inStock.length) colours = colours.filter(function (c) { return inStock.indexOf(c) > -1; });
      var chosen = preselect && colours.some(function (c) { return c.toLowerCase() === preselect.toLowerCase(); })
        ? colours.filter(function (c) { return c.toLowerCase() === preselect.toLowerCase(); })[0]
        : colours[0];
      state = { p: p, ci: ci, si: si, colours: colours, colour: chosen, qty: Object.create(null) };
      modal.querySelector('.bqb-title').textContent = p.title;
      modal.querySelector('.bqb-full').href = '/products/' + p.handle;
      var low = Math.min.apply(null, p.variants.map(function (x) { return x.price; }));
      modal.querySelector('.bqb-low').textContent = money(low);
      renderSwatches();
      renderSizes();
    });
  }

  function pill(name) {
    modal.querySelector('.bqb-colourname').textContent = name || '';
    modal.querySelector('.bqb-colourchip').style.backgroundColor = hexFor(name) || '#ddd';
  }
  function renderSwatches() {
    var wrap = modal.querySelector('.bqb-swatches');
    wrap.innerHTML = '';
    if (!wrap.__npPreview) {
      wrap.__npPreview = true;
      wrap.addEventListener('mouseleave', function () { if (state) pill(state.colour); });
      wrap.addEventListener('focusout', function () {
        setTimeout(function () { if (state && !wrap.contains(document.activeElement)) pill(state.colour); }, 0);
      });
    }
    modal.querySelector('.bqb-colourname').textContent = state.colour || '';
    modal.querySelector('.bqb-colourchip').style.backgroundColor = hexFor(state.colour) || '#ddd';
    modal.querySelector('.bqb-colourcount').textContent =
      state.colours.length + (state.colours.length === 1 ? ' color' : ' colors');
    state.colours.forEach(function (name) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'bqb-swatch' + (name === state.colour ? ' is-active' : '');
      b.style.backgroundColor = hexFor(name) || '#ddd';
      b.title = name; b.setAttribute('aria-label', name);
      /* C391: hovering or keyboard-focusing a swatch previews it in the colour pill; the pill returns to the selected
         colour when the pointer leaves the swatches (listener on the wrap, below) */
      b.addEventListener('mouseenter', function () { pill(name); });
      b.addEventListener('focus', function () { if (b.matches(':focus-visible')) pill(name); });
      b.addEventListener('click', function () {
        state.colour = name;
        state.qty = Object.create(null);   /* totals reset when the colour changes */
        renderSwatches(); renderSizes();
      });
      wrap.appendChild(b);
    });
    var hero = modal.querySelector('.bqb-hero');
    var match = state.p.variants.filter(function (v) {
      return state.ci < 0 || (v.options && v.options[state.ci] === state.colour);
    })[0];
    var img = (match && match.featured_image && match.featured_image.src) ||
              (state.p.featured_image) || '';
    if (img) { hero.src = img.indexOf('?') > -1 ? img + '&width=700' : img + '?width=700'; }
    hero.alt = state.p.title;
    /* C390: the popup photo gets the same backdrop fill as the cards (np-edgefill.js); repainted once the popup is on screen */
    if (window.NPEdge) {
      window.NPEdge.fill(hero, hero.parentNode);
      setTimeout(function () { if (window.NPEdge) window.NPEdge.repaint(); }, 60);
    }
  }

  /* C338 (Justin 2026-09-23, "on quick buy if its one size lets make the qty selector to the left of add
     to cart on 1 line"): a colour with a single size (OS / One Size) skips the "Choose size(s)" grid — one
     lonely column with an empty box — and gets a − qty + stepper beside Add to cart instead. It starts at 1
     so the button is ready to press; typing 0 or clearing it disables the button as before. */
  function renderSingle(v, host) {
    modal.classList.add('is-single');
    /* C405: one size = no size columns, so the struck retail price sits beside the big price */
    var lowEl = modal.querySelector('.bqb-low');
    var oldWas = lowEl.querySelector('.bqb-low__was');
    if (oldWas) oldWas.remove();
    var lw = document.createElement('s');
    lw.className = 'bqb-low__was';
    lw.textContent = money(wasFor(v));
    lowEl.appendChild(lw);
    host.hidden = false;
    if (!(v.id in state.qty)) state.qty[v.id] = 1;
    var label = sizeLabel(state.si > -1 && v.options ? v.options[state.si] : v.title);
    var step = document.createElement('div');
    step.className = 'bqb-step';
    var down = document.createElement('button'); down.type = 'button'; down.className = 'bqb-step__btn';
    down.textContent = '\u2212'; down.setAttribute('aria-label', 'Decrease quantity');
    var input = document.createElement('input');
    input.type = 'text'; input.inputMode = 'numeric'; input.className = 'bqb-step__qty';
    input.setAttribute('aria-label', (label || 'Item') + ' quantity');
    var up = document.createElement('button'); up.type = 'button'; up.className = 'bqb-step__btn';
    up.textContent = '+'; up.setAttribute('aria-label', 'Increase quantity');
    function set(n, floor) {
      n = Math.max(floor || 0, parseInt(n, 10) || 0);
      input.value = n === 0 ? '' : String(n);
      state.qty[v.id] = n;
      total();
    }
    down.addEventListener('click', function () { set((parseInt(input.value, 10) || 0) - 1, 1); });
    up.addEventListener('click', function () { set((parseInt(input.value, 10) || 0) + 1, 1); });
    input.addEventListener('input', function () { set(input.value); });
    step.appendChild(down); step.appendChild(input); step.appendChild(up);
    host.appendChild(step);
    set(state.qty[v.id]);
  }

  function renderSizes() {
    var wrap = modal.querySelector('.bqb-sizes');
    wrap.innerHTML = '';
    var rows = state.p.variants.filter(function (v) {
      return state.ci < 0 || (v.options && v.options[state.ci] === state.colour);
    });
    var buyq = modal.querySelector('.bqb-buyqty');
    buyq.innerHTML = ''; buyq.hidden = true;
    modal.classList.remove('is-single');
    /* C406 (Justin 2026-09-23, "one size products you can move the size entry to the same spot when there are only two or
       three sizes, it doesn't have to be to the left of the add to cart button"): a single size is one ordinary size
       column now; renderSingle (C338) is no longer used. */
    var lowWas = modal.querySelector('.bqb-low__was'); if (lowWas) lowWas.remove();
    rows.forEach(function (v) {
      var label = sizeLabel(state.si > -1 && v.options ? v.options[state.si] : (rows.length === 1 ? 'One Size' : v.title));
      var col = document.createElement('div');
      col.className = 'bqb-size' + (v.available ? '' : ' is-out');

      var nameEl = document.createElement('div');
      nameEl.className = 'bqb-size__name';
      nameEl.textContent = label;
      col.appendChild(nameEl);

      var field = document.createElement('div');
      field.className = 'bqb-field';
      if (!v.available) {
        field.innerHTML = '<span class="bqb-out">Sold out</span>';
      } else {
        /* selectionStart is unsupported on type=number, so this is a text input with
           inputmode numeric; the spinner is drawn here instead of relying on the browser's. */
        var input = document.createElement('input');
        input.type = 'text'; input.inputMode = 'numeric'; input.className = 'bqb-qty';
        input.value = ''; input.placeholder = '';
        input.setAttribute('aria-label', label + ' quantity');
        var spin = document.createElement('span');
        spin.className = 'bqb-spin';
        var up = document.createElement('button'); up.type = 'button'; up.className = 'bqb-up';
        up.setAttribute('aria-label', 'Increase ' + label);
        var down = document.createElement('button'); down.type = 'button'; down.className = 'bqb-down';
        down.setAttribute('aria-label', 'Decrease ' + label);
        function set(n) {
          n = Math.max(0, parseInt(n, 10) || 0);
          input.value = n === 0 ? '' : String(n);
          state.qty[v.id] = n;
          total();
        }
        up.addEventListener('click', function () { set((parseInt(input.value, 10) || 0) + 1); });
        down.addEventListener('click', function () { set((parseInt(input.value, 10) || 0) - 1); });
        input.addEventListener('input', function () { set(input.value); });
        selectAllOnFocus(input);
        spin.appendChild(up); spin.appendChild(down);
        field.appendChild(input); field.appendChild(spin);
      }
      col.appendChild(field);

      /* C406 ("do the strikethrough underneath the price, which should be underneath the size"): box, price, struck price */
      var priceEl = document.createElement('div');
      priceEl.className = 'bqb-size__price';
      priceEl.textContent = money(v.price);
      col.appendChild(priceEl);

      var wasEl = document.createElement('div');
      wasEl.className = 'bqb-size__was';
      wasEl.textContent = money(wasFor(v));
      col.appendChild(wasEl);

      wrap.appendChild(col);
    });
    total();
  }

  function total() {
    var n = 0, cents = 0;
    state.p.variants.forEach(function (v) {
      var q = state.qty[v.id] || 0;
      if (q) { n += q; cents += q * v.price; }
    });
    var btn = modal.querySelector('.bqb-add');
    btn.disabled = n === 0;
    btn.textContent = n === 0 ? 'Add to cart' : 'Add ' + n + (n === 1 ? ' item - ' : ' items - ') + money(cents);
  }

  /* C308: the shared add confirmation — a white card top right with a green tick, matching what
     dtftransfers.com shows. toast(title, sub); the old single-string call still works. Built here
     rather than in the snippet so the rail, the quick-buy bar and the collection pages all raise the
     same card. The snippet keeps a visually identical inline fallback for the case where this asset
     is served stale (C307). */
  function toastIcon() {
    var ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('class', 'bqb-toast__icon');
    svg.setAttribute('viewBox', '0 0 26 26');
    svg.setAttribute('aria-hidden', 'true');
    var c = document.createElementNS(ns, 'circle');
    c.setAttribute('cx', '13'); c.setAttribute('cy', '13'); c.setAttribute('r', '13');
    c.setAttribute('fill', '#4DB47F');
    var p = document.createElementNS(ns, 'path');
    p.setAttribute('d', 'M7.5 13.4l3.6 3.6 7.4-7.4');
    p.setAttribute('fill', 'none'); p.setAttribute('stroke', '#fff');
    p.setAttribute('stroke-width', '2.4'); p.setAttribute('stroke-linecap', 'round');
    p.setAttribute('stroke-linejoin', 'round');
    svg.appendChild(c); svg.appendChild(p);
    return svg;
  }
  function toast(title, sub) {
    var t = document.createElement('div');
    t.className = 'bqb-toast';
    t.setAttribute('role', 'status');
    var body = document.createElement('div');
    body.className = 'bqb-toast__body';
    var h = document.createElement('div');
    h.className = 'bqb-toast__title';
    h.textContent = title || 'Added to cart';
    body.appendChild(h);
    if (sub) {
      var d = document.createElement('div');
      d.className = 'bqb-toast__sub';
      d.textContent = sub;
      body.appendChild(d);
    }
    var x = document.createElement('button');
    x.type = 'button';
    x.className = 'bqb-toast__x';
    x.setAttribute('aria-label', 'Dismiss');
    x.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">' +
      '<path d="M3.5 3.5l9 9M12.5 3.5l-9 9" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';
    t.appendChild(toastIcon());
    t.appendChild(body);
    t.appendChild(x);
    /* a showModal() dialog owns the top layer, so a card on <body> would sit behind it (C306) */
    (document.querySelector('dialog:modal') || document.body).appendChild(t);
    var gone = false;
    function close() {
      if (gone) return;
      gone = true;
      t.classList.remove('is-in');
      setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 400);
    }
    x.addEventListener('click', close);
    setTimeout(function () { t.classList.add('is-in'); }, 20);
    setTimeout(close, 2000);  /* C310 (Justin): 2 seconds */
    return t;
  }
  window.npBlanksToast = toast;

  /* C311 (Justin 2026-09-22, "the cart icon needs to be updated with # with quick buy as well with the
     toast"): refreshCart() rebuilds the drawer but left the header badge on its page-load count, so the
     icon still read empty after an add. Same recipe the by-size builder and artwork-library-v2 use
     (see snippets/artwork-library-v2.liquid syncCartUi): repaint [data-header-cart-count] — TEXT AND the
     data-count attribute, which is what the badge's own CSS keys off — plus the total, from a no-store
     /cart.js, then fire the theme's 'cart-updated' so every other listener reacts as it would to any add. */
  function syncCartBadges() {
    return fetch('/cart.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var n = c && Number(c.item_count);
        if (isFinite(n)) {
          document.querySelectorAll('[data-header-cart-count], [data-cart-count]').forEach(function (el) {
            el.textContent = String(n);
            if (el.hasAttribute('data-count')) el.setAttribute('data-count', String(n));
          });
        }
        if (c && typeof c.total_price === 'number') {
          var money = '$' + (c.total_price / 100).toFixed(2);
          document.querySelectorAll('[data-header-cart-total]').forEach(function (el) { el.textContent = money; });
        }
        try { document.dispatchEvent(new CustomEvent('cart-updated', { bubbles: true })); } catch (e) {}
      })
      .catch(function () {});
  }
  window.npBlanksSyncCart = syncCartBadges;

  function addToCart() {
    if (!state) return;
    var items = [];
    state.p.variants.forEach(function (v) {
      var q = state.qty[v.id] || 0;
      if (q > 0) items.push({ id: v.id, quantity: q });
    });
    if (!items.length) return;
    var btn = modal.querySelector('.bqb-add');
    btn.disabled = true; btn.textContent = 'Adding...';
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json(); })
      .then(function () {
        /* C303: the upsell rail hides itself once the cart holds a blank, which meant adding FROM the rail
           made the rail vanish with nothing to show for it. Mark the rail as used so that watcher leaves it
           alone for the rest of this page view, and confirm the add. */
        window.__grtRailUsed = true;
        var n = items.reduce(function (a, i) { return a + i.quantity; }, 0);
        toast('Added to cart', n + (n === 1 ? ' item, ' : ' items, ') + (state.p.title || ''));
        /* component-cart.js documents refreshCart() as the hook for apps */
        if (typeof window.refreshCart === 'function') window.refreshCart();
        syncCartBadges();
        /* C312 (Justin 2026-09-22, "when you quick buy on cart page it needs to reload so the hat shows in
           cart"): the cart page renders its line list server side, so an AJAX add leaves the new line
           invisible there. Reload — after a beat, so the toast is seen first. Everywhere else the shopper is
           mid-flow and a reload would throw away their place. */
        if (/^\/(?:[a-z]{2}(?:-[a-zA-Z]{2})?\/)?cart\/?$/.test(window.location.pathname)) {
          setTimeout(function () { window.location.reload(); }, 1200);
          return;
        }
        /* C309 (Justin 2026-09-22): STAY OPEN after an add — the shopper is often buying the same style in
           another colour, and closing the modal made them re-open it from the card every time. Clearing the
           quantities is the reset: renderSizes() rebuilds the inputs empty and calls total(), which puts the
           button back to a disabled "Add to cart". The toast is the confirmation that the add landed. */
        state.qty = Object.create(null);
        renderSizes();
      })
      .catch(function () { btn.disabled = false; btn.textContent = 'Could not add - try again'; });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-bqb-open]') : null;
    if (!t) return;
    e.preventDefault(); e.stopPropagation();
    var card = t.closest('.product-item, [data-bqb-handle]');
    /* C268: whatever colour the shopper picked on the card opens selected in the modal */
    var pre = card ? card.getAttribute('data-npbc-colour-name') : null;
    open(t.getAttribute('data-bqb-open'), pre);
  }, true);

  addTriggers(document);
  /* C397: the theme replaces #main-collection-product-grid on every filter change; its container survives */
  var grid = document.getElementById('CollectionProductGrid') || document.getElementById('main-collection-product-grid');
  if (grid && window.MutationObserver) {
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      setTimeout(function () { pending = false; addTriggers(document); }, 30);   /* C397: not rAF (background tabs) */
    }).observe(grid, { childList: true, subtree: true });
  }
})();
